import { getVinculacionTab } from '../modules/views/dashboard/Administracion/Vinculaciones/vinculacionTabs'
import { getVinculacionAvailableAmount } from './vinculacionAmounts'

export const isPendingConciliation = row => {
  const balance = row?.auxiliar ?? row?.deuda?.auxiliar
  if (balance != null && String(balance).trim() !== '' && Number.isFinite(Number(balance)) && Number(balance) <= 0) return false
  return !['CONCILIADO', 'CONCILIADA', 'PAGADO', 'COBRADO'].includes(String(row?.status ?? '').trim().toUpperCase()) && row?.isReconciled !== true && getVinculacionAvailableAmount(row) > 0
}
export const getCounterpartyType = row => {
  const tab = getVinculacionTab(row)
  if (['cargo', 'pago-masivo'].includes(tab)) return 'venta'
  if (['abono', 'cobro-masivo'].includes(tab)) return 'compra'
  const type = String(row?.tipoMovimiento ?? row?.type ?? '').toLowerCase()
  if (['cargo', 'egreso'].includes(type) || Number(row?.montoCargo) > 0) return 'venta'
  if (['abono', 'ingreso'].includes(type) || Number(row?.montoAbono) > 0) return 'compra'
  return null
}
